/**
 * Central configuration for the Gestionale Centri di Formazione (M.A.S.E. ecosystem).
 *
 * MIGRATION (OVH -> AWS): all infrastructure values are now read from environment
 * variables (REACT_APP_*) so the same build can be deployed against the shared AWS
 * infrastructure used by the M.A.S.E. app. The fallback values below match the current
 * AWS (eu-west-1) infrastructure and are used only when an env var is not provided.
 *
 * NOTE: this is a Create-React-App project, so only variables prefixed with
 * REACT_APP_ are exposed to the browser at build time. Define them in `.env`
 * (see `.env.example`). Never put long-lived DB or IAM secrets that must stay
 * private here: the database (AWS RDS PostgreSQL, shared with M.A.S.E.) is reached
 * exclusively through the serverless backend (API Gateway), never directly by the
 * browser. See MIGRATION_REPORT.md for the RDS connection details.
 */

const env = (typeof process !== "undefined" && process.env) ? process.env : {};

const ServerConfig = {
  AWS: {
    s3Bucket: {
      Region: env.REACT_APP_AWS_REGION || "eu-west-1",
      BucketName: env.REACT_APP_S3_BUCKET || "new-mase",
      ApiVersion: env.REACT_APP_S3_API_VERSION || "2006-03-01",
      // Credentials used by the browser for direct S3 uploads (aws-sdk).
      // Provide via env; prefer scoped, upload-only IAM keys.
      AccessKeyId: env.REACT_APP_AWS_ACCESS_KEY_ID || "",
      SecretKeyId: env.REACT_APP_AWS_SECRET_ACCESS_KEY || "",
    },
    Cognito: {
      // Centri di formazione user pool (centri_formazione_pool)
      Region: env.REACT_APP_COGNITO_REGION || "eu-west-1",
      UserPoolId: env.REACT_APP_COGNITO_USER_POOL_ID || "eu-west-1_DdsaqzSfL",
      ClientId: env.REACT_APP_COGNITO_CLIENT_ID || "1ddkv1c99ltpp1980qe5vs99jd",
    },
    Serverless: {
      // Primary backend APIs (AWS API Gateway, eu-west-1)
      API_BASE_URL_1:
        env.REACT_APP_API_BASE_URL_1 ||
        "https://58m0abz9m7.execute-api.eu-west-1.amazonaws.com/dev/api/v1",
      API_BASE_URL_2:
        env.REACT_APP_API_BASE_URL_2 ||
        "https://nmzwwtlkne.execute-api.eu-west-1.amazonaws.com/dev/api/v1",
      // Legacy CRM (lead4life) backend still used by leads/contracts/offers views.
      LEGACY_CRM_API_BASE_URL:
        env.REACT_APP_LEGACY_CRM_API_BASE_URL ||
        "https://45bm2i72wc.execute-api.eu-west-1.amazonaws.com/dev/api/v1",
      // Support ticketing proxy (Lambda) -> forwards to M.A.S.E. Command Center.
      // The Command Center x-api-key is kept server-side in the Lambda, never here.
      SUPPORT_TICKET_URL:
        env.REACT_APP_SUPPORT_TICKET_URL ||
        (env.REACT_APP_API_BASE_URL_1 ||
          "https://58m0abz9m7.execute-api.eu-west-1.amazonaws.com/dev/api/v1") +
          "/support/ticket",
    },
    S3: {
      URL:
        env.REACT_APP_S3_URL ||
        "https://new-mase.s3.eu-west-1.amazonaws.com",
    },
  },
  // Single Sign-On entry point for the M.A.S.E. ecosystem.
  SSO_URL:
    env.REACT_APP_SSO_URL ||
    "http://sso-new-mase.s3-website-eu-west-1.amazonaws.com/",
  authTimeout: Number(env.REACT_APP_AUTH_TIMEOUT) || 18000,
  platformName: env.REACT_APP_PLATFORM_NAME || "MASE",
};

export { ServerConfig };
